import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";
import { AbcCore, ConvertHelper } from "@barthauer/abc/core";
import { ResourceManagerService } from "@barthauer/abc/core/resources";
import { LoginInfo } from "@barthauer/basys/core/authentication";
import { BasysMapFrameService } from "@barthauer/basys/map-frame";
import { ResourceSet } from "libs/abc/core/resources/src/lib/resource-set";
import { Observable, Subject, Subscription } from "rxjs";
import { startWith, switchMap, takeUntil, tap } from "rxjs/operators";
import { AppService } from "../services/app.service";
import { MobileOrderViewModel } from "../viewModels/mobileData.viewModel";
import { Router } from "@angular/router";

@Component({
  selector: "app-order-selection",
  templateUrl: "./order-selection.component.html",
  styleUrls: ["./order-selection.component.css"],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class OrderSelectionComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  public resAsync: Promise<ResourceSet>;
  public res = ResourceSet.Empty;
  private readonly refreshSubject$ = new Subject<void>();
  private destroy$ = new Subject<void>(); // used to cancel Observable chains when component is destroyed
  private subscriptions: Subscription[] = [];
  ordersObservable$: Observable<MobileOrderViewModel[]>;
  loginInfoObservable$: Observable<LoginInfo>;
  loading: boolean;
  ConvertHelper = ConvertHelper;
  public canLogout: boolean = true;
  public filterText: string = "";

  constructor(
    public appService: AppService,
    private resourceService: ResourceManagerService,
    private frame: BasysMapFrameService,
    private abcCore: AbcCore,
    private router : Router
  ) {
    this.resAsync = this.resourceService.getResourceSet('abc-maintenance-opera');
    // fake emission of a click so that initial data can be loaded
    this.ordersObservable$ = this.refreshSubject$.pipe(
      startWith(undefined),
      switchMap(() => this.appService.queryMobileOrdersForSelection$),
      tap(() => (this.loading = false)),
    );
    this.loginInfoObservable$ = this.frame.getLoginInfo();
  }

  async ngOnInit() {
    this.res = await this.resAsync;
    this.canLogout = await this.frame.canLogout.toPromise();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.frame.loadingScreenService.clearTasks();
    }, 2000);
  }

  public selectOrder(order: MobileOrderViewModel): void {
    this.appService.loadOrderAsync(order).then((_) => {
      this.router.navigate([{ outlets: { mainOutlet: [] } }]);
    });
  }
  public refresh(): void {
    this.appService.armMobileOrdersQuery();
    this.loading = true;
    this.refreshSubject$.next(null);
  }

  public selectProfile(): void {
    this.frame.selectProfile();
  }

  public logout(): void {
    this.subscriptions.push(
      this.frame
        .logout()
        .pipe(takeUntil(this.destroy$))
        .subscribe({ error: (err) => this.abcCore.error.publish(err) }),
    );
  }

  public trackById(index, item) {
    return item.id;
  }

  ngOnDestroy(): void {
    this.refreshSubject$.complete();
    this.destroy$.next(null); // trigger the unsubscribe
    this.destroy$.complete(); // finalize & clean up the subject stream
    this.subscriptions.forEach((element) => {
      element.unsubscribe();
    });
    this.appService.dispose();
  }
}
